import { appStateSelectors } from "..";
import { actionTypes } from "../actions";
import { getFirstViewFromLayout, nextViewInLayout } from "./utils";

// TODO: Ideally this would go on screen order, but for now just jump to the first one
const previousViewInLayout = (globalState, viewId) =>
  appStateSelectors.getOpenViewsById(globalState).find((v, k) => k === v.viewId && k !== viewId);

const setActiveView = (viewId, currentActiveViewId, prevGlobalState) => {
  // Only change if the new view type exists
  const doesViewExist = appStateSelectors.getOpenViewsById(prevGlobalState).find(v => v.get("viewId") === viewId);
  return doesViewExist ? viewId : currentActiveViewId;
};

const activeView = (state, action, prevGlobalState) => {
  switch (action.type) {
    case actionTypes.REPLACE_OPEN_VIEWS:
      return action.openViews.activeView;
    case actionTypes.SET_ACTIVE_VIEW:
      return setActiveView(action.viewId, state, prevGlobalState);
    case actionTypes.SET_NEXT_ACTIVE_VIEW: {
      const viewId = action.viewId;
      const rootLayout = appStateSelectors.getRootLayout(prevGlobalState);
      const nextViewId = nextViewInLayout(rootLayout, viewId);
      return setActiveView(nextViewId ? nextViewId : getFirstViewFromLayout(rootLayout), state, prevGlobalState);
    }
    case actionTypes.POPOUT_VIEW:
    case actionTypes.REMOVE_VIEW: {
      // If we are removing the active view, pick a new one
      return action.viewId !== state ? state : previousViewInLayout(prevGlobalState, action.viewId).get("viewId");
    }
    case actionTypes.ADD_VIEW:
    case actionTypes.SPLIT_VIEW_HORIZONTAL:
    case actionTypes.SPLIT_VIEW_VERTICAL:
      // If they add one, select the newly added split...
      return action.viewId;
    default: {
      if (!state) {
        const prev = previousViewInLayout(prevGlobalState, action.viewId);
        return prev ? prev.viewId : state;
      }
      return state;
    }
  }
};

export default activeView;
